var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-app-bar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.t({s: 'information', component: 'Navigation'})))])],1),_c('InfoAlert'),_c('Tabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }